import { useEffect, useRef } from 'react';
import { GetStreamHandler } from '../GetstreamHandler';
import { CUSTOM_EVENTS } from '../../../utils/constants';
import { useVideoCallStore } from '../videocall.zustandstore';

const useMonitorGSEvents = () => {
    const getstreamHandler = useRef(new GetStreamHandler());
    const { endCall } = useVideoCallStore();

    useEffect(() => {
        const gsHandler = getstreamHandler.current;
        const controller = new AbortController();
        const monitorGSEvents = (e) => {
            // console.log({e});
            const event = e.detail?.event;
            // NOTE: These 2 conditions are written assuming that the call is 1:1 only
            // "call.session_participant_count_updated"
            if (event && event.type) {
                switch (event.type) {
                    case 'call.session_participant_left':
                    case 'call.rejected':
                    case 'call.ended':
                        endCall();
                        break;

                    // case 'call.missed':
                    //     console.log('Call Missed');
                    //     break;

                    default:
                }
            }
            // if (event && event.type && event.participant && event.type === 'call.session_participant_left') {
            //     // console.log('PARTICIPANT LEFT');
            //     // // check if the participant is not myself
            //     // const {participant: {user: {id}}} = event;
            //     // if (id !== gsHandler.getMyID()) {
            //     //     setCall(null);
            //     // }
            //     endCall();
            // } else if (event && event.type && event.type === 'call.rejected') {
            //     // console.log('PARTICIPANT LEFT');
            //     // // check if the participant is not myself
            //     // const {participant: {user: {id}}} = event;
            //     // if (id !== gsHandler.getMyID()) {
            //     //     setCall(null);
            //     // }
            //     endCall();
            // } else if (event && event.type && event.type === 'call.ended') {
            //     // console.log('PARTICIPANT LEFT');
            //     // // check if the participant is not myself
            //     // const {participant: {user: {id}}} = event;
            //     // if (id !== gsHandler.getMyID()) {
            //     //     setCall(null);
            //     // }
            //     endCall();
            // }
        };

        document.addEventListener(CUSTOM_EVENTS.MONITOR_GS_EVENTS, monitorGSEvents, { signal: controller.signal });
        return () => {
            controller.abort();
            gsHandler.destroy();
        };
    }, [endCall]);
};

export default useMonitorGSEvents;